export default "__VITE_ASSET__Bdad$QZf__"